import React from 'react';
import cc from 'classcat';

import { useSiteQuery } from '../../../hooks';
import { EmailButton } from '../../index';

import query from '../../PageContent/ServicesGlobals/servicesGlobals.graphql';

import styles from './styles.module.scss';

interface Props {
  consultant?: Maybe<ConsultantsFragment>[] | ConsultantsFragment;
  locationTitle?: string;
  backgroundImage?: string | null;
  hideContactCtas?: boolean | null;
}

const RetirementVillageServicesGlobals = ({ consultant, locationTitle, backgroundImage, hideContactCtas }: Props) => {
  const [{ data }] = useSiteQuery<ServicesGlobalsQuery>({ query });
  const services = data?.retirementVillages?.servicesCategories;

  const consultantData = Array.isArray(consultant) ? consultant[0] : consultant;
  const firstName = consultantData?.title?.split(' ')?.[0] || consultantData?.title;

  if (!services || services.length === 0) {
    return null;
  }

  // Get all services for display
  const allServices = services.filter((service): service is ServicesCategoryFragment =>
    service !== null && service !== undefined
  );

  return (
    <div className={cc(['section', styles.servicesSection])}>
      <div className="container">
        <div className={styles.servicesGrid}>
          <div className={styles.contentColumn}>
            <div className={styles.sectionLabel}>ADDITIONAL SERVICES</div>
            <h2 className={styles.heading}>Expand your experience</h2>
            <p className={styles.description}>
              Beyond the standard services at our retirement villages, there are a number of additional options to purchase including:
            </p>

            <div className={styles.servicesList}>
              {allServices.map((service, index) => {
                const icon = service?.icon?.[0]?.url;
                const title = service?.title;
                
                return (
                  <div key={index} className={styles.serviceItem}>
                    {icon && (
                      <div className={styles.serviceIcon}>
                        <img src={icon} alt={title || ''} />
                      </div>
                    )}
                    <span className={styles.serviceTitle}>{title}</span>
                  </div>
                );
              })}
            </div>

            {!hideContactCtas && (
              <div className={styles.ctaButton}>
                {consultantData?.phone ? (
                  <a
                    href={`tel:${consultantData.phone.replace(/[^\d\+]/g, '')}`}
                    title={`Click to call ${firstName} to book a tour`}
                    className={'newStyleButtonOverrideSolid'}
                  >
                    Call {firstName} to book a tour
                  </a>
                ) : (
                  <EmailButton section="Retirement Village Services" name={locationTitle || 'Retirement Village'} />
                )}
              </div>
            )}
          </div>

          {backgroundImage && (
            <div className={styles.imageColumn}>
              <div className={styles.imageWrapper}>
                <img src={backgroundImage} alt="Additional services" />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RetirementVillageServicesGlobals;

